export default __webpack_public_path__ + "static/media/1063.e4d7d1d1.png";